import { Form, Formik } from "formik";

import { useParams } from "react-router-dom";
import { BANK_INITIAL_VALUES, bankSchema } from "../../models/bank";
import Button from "../UI/Button";
import TextInput from "../UI/TextInput";
import { useModal } from "../../hooks/use-modal.jsx";
import useBanks from "../../hooks/use-banks";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import { useState } from "react";
import Callout from "../UI/Callout";
import { handleAPIError } from "../../utils/index.jsx";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Select from "../UI/Select";
import useProfileBailleurs from "../../hooks/use-profile-bailleurs";
import PermissionScope from "../../store/PermissionScope";
import Checkbox from "../UI/Checkbox";
import useAuth from "../../hooks/use-auth.js";
import Accordion, { AccordionItem } from "../UI/Accordion";
import styles from "./BankForm.module.css";

export default function BankForm({ edit }) {
  const { isPro } = useAuth();
  const { profileBailleurs } = useProfileBailleurs();
  const { bankId } = useParams();
  const [Modal, closeModal] = useModal(true);
  const { banks, updateBank, addBank, deleteBank } = useBanks();
  const [error, setError] = useState("");

  if (!banks) {
    return null;
  }
  const bank = banks.find((b) => b.id === parseInt(bankId));

  async function submitHandler(values) {
    try {
      if (edit) {
        await updateBank(parseInt(bankId), sanitizeValues(values));
      } else {
        await addBank(sanitizeValues(values));
      }
      closeModal();
      setError("");
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  async function deleteBankHandler(bankId) {
    try {
      await deleteBank(bankId);
      closeModal();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Modal>
      <PermissionScope profileId={bank?.id_profile_nom ?? null}>
        <Formik
          initialValues={toInitialValuesFromSchema(
            bankSchema,
            bank,
            BANK_INITIAL_VALUES,
          )}
          enableReinitialize={true}
          validationSchema={bankSchema}
          onSubmit={submitHandler}
        >
          <Form>
            <TextInput
              type="text"
              name="nom"
              placeholder="SCI HENRY"
              label={"Nom du compte"}
            />
            <TextInput
              type="number"
              name="alert"
              placeholder="Pas d'alerte"
              label={"Seuil d'alerte"}
              unit={"€"}
            />
            <Select name="id_profile_nom">
              <option value="">Affecter à un profil bailleur</option>
              {profileBailleurs.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.nom_profile}
                </option>
              ))}
            </Select>
            {isPro && (
              <Checkbox name="compte_gestion">
                Compte de gestion (fonds mandants) — entre dans la comptabilité
                pro : rapprochement, pointe, journal
              </Checkbox>
            )}
            <Accordion className={styles.advanced}>
              <AccordionItem title="Avancé" variant="plain">
                <TextInput
                  type="text"
                  name="accounting_account_number"
                  placeholder="512000"
                  label="Compte comptable (export FEC)"
                />
              </AccordionItem>
            </Accordion>
            <div className="text-right">
              <Button
                type="button"
                variant="secondary"
                onClick={() => deleteBankHandler(parseInt(bankId))}
                className={"marginR10"}
                requiresWrite
              >
                Supprimer
              </Button>
              <FormikSubmitButton requiresWrite>Valider</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        </Formik>
      </PermissionScope>
    </Modal>
  );
}
